import {Modal} from 'react-bootstrap';
import React, {useContext, useState} from 'react';
import { UserContext } from '../Contexts/UserContext';
import LoginAuth from './LoginAuth';
import { userService } from '../Services/userService';
import toast from 'react-hot-toast';
import { productSettings } from '../Utils/productSettings';
import { useNavigate } from 'react-router';

const LoginModal = (props) => {
    const navigate = useNavigate();
    const {openLoginModal} = useContext(UserContext);
    const [showLogin, setShowLogin] = useState(true);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [forgotPasswordUsername, setForgotPasswordUsername] = useState('');
    const [userMgs, setUserMgs] = useState('');
    const complete = () => {
        openLoginModal(false);
        if(productSettings.isGMR) {
            navigate("/gmr");
        } else {
            props.setShowSelectOrgModal(true);
        }
    };

    const showForgotPasswordScreen = () => {
        setShowForgotPassword(true);
        setShowLogin(false);
    }

    const showLoginScreen = () => {
        setShowForgotPassword(false);
        setShowLogin(true);
    }

    const sendResetPasswordLink = (e) => {
        setUserMgs('');
        e.preventDefault();
        if (forgotPasswordUsername?.length > 0) {
            userService.forgotPassword(forgotPasswordUsername).then(res => {
                if (res.message == "Success") {
                    setUserMgs("Reset Password Link sent to your Email");
                }
                else if (res.message == "UserNotFound") {
                    setUserMgs("User Not Found. Please Enter a Valid UserName");
                }
                else if (res.message == "SentRecently") {
                    setUserMgs("Reset Password Link already sent to your Email. Please check your Mailbox");
                }
            }).catch(e => {
                toast.error("Failed to send Reset Password Link");
            });
        }
    }

    return (
        <>
            <Modal
                show={() => openLoginModal(true)}
                onHide={() => openLoginModal(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName="signin-modal-dialog"
                className="signin-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Log in to {productSettings.productName}.</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        showLogin &&
                        <div className='login-container'>
                            <LoginAuth complete={complete} />
                            <div className='forgot-password'>
                                <a className='forgot-password-link' onClick={showForgotPasswordScreen}>Forgot Password?</a>
                            </div>
                        </div>
                    }
                    {
                        showForgotPassword &&
                        <div className='forgot-password-container'>
                            <form onSubmit={sendResetPasswordLink}>
                                <div className='forgot-password-form'>
                                    <h2>Forgot your password?</h2>
                                    <p>Enter your email to reset it!</p>
                                    <label htmlFor='username' className='form-label'>Enter the UserName : </label>
                                    <input type="email" className="form-control" required value={forgotPasswordUsername} onInput={e => setForgotPasswordUsername(e.target.value)}/>
                                    <div className='user-mgs'><span>{userMgs}</span></div>
                                    <input type="submit" className="btn btn-primary send-reset-pwd-btn" value="Submit"/>
                                </div>
                                <div className='form-group forgot-password-actions'>
                                    <a className='login-link' onClick={showLoginScreen}>&#8592; Return back to Login</a>
                                   
                                </div>
                            </form>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </>
    );
}

export default LoginModal;